export default class DtoStationContacts {
    constructor(obj) {
        this.stationCode = obj.stationCode
        this.stationType = obj.stationType
        this.groupCode = obj.groupCode
        this.contactCode = obj.contactCode
    }
}